var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "info-all"
    },
    [
      _c(
        "el-aside",
        {
          staticClass: "aside-left",
          style: { height: _vm.boxHeight },
          attrs: { width: "2.80rem" }
        },
        [
          _c("p", { staticClass: "page-total" }, [
            _c("span", { staticClass: "tit" }, [_vm._v("文件签署列表")]),
            _c("span", [_vm._v("共" + _vm._s(_vm.fileList.length) + "个")])
          ]),
          _c(
            "div",
            { staticClass: "page-con" },
            [
              _vm._l(_vm.fileList, function(file, i) {
                return [
                  _c(
                    "div",
                    {
                      key: i,
                      staticClass: "list",
                      class: _vm.checkAct === i ? "active" : "",
                      on: {
                        click: function($event) {
                          return _vm.chooseTemp(file, i)
                        }
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: { effect: "light", placement: "right-start" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [_vm._v("此模板已设置变量")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "varable",
                              class: file.finished ? "finish" : "never"
                            },
                            [
                              _vm._v("变量"),
                              _c("i", {
                                staticClass: "el-icon-check check-icon"
                              })
                            ]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "bx" }, [
                        _c("img", {
                          attrs: { src: _vm.fileIcon(file.fileName) }
                        })
                      ]),
                      _c(
                        "p",
                        {
                          staticClass: "title",
                          attrs: { title: file.tplName }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(file.tplName || file.fileName) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ]
      ),
      _c("transition", { attrs: { name: "el-fade-in" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.drawerShow,
              expression: "drawerShow"
            }
          ],
          staticClass: "aside",
          style: { height: _vm.boxHeight }
        })
      ]),
      [
        _c(
          "el-main",
          { staticClass: "main-content", style: { height: _vm.boxHeight } },
          [
            _c("file-tpl", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTpl && _vm.checkTpl.tplVersion === 2,
                  expression: "checkTpl && checkTpl.tplVersion === 2"
                }
              ],
              ref: "file_tpl",
              attrs: { fileTplItem: _vm.checkTpl },
              on: {
                "update:fileTplItem": function($event) {
                  _vm.checkTpl = $event
                },
                "update:file-tpl-item": function($event) {
                  _vm.checkTpl = $event
                },
                turnFirst: _vm.turnFirst,
                varListADD: _vm.varListADD
              }
            }),
            _c("web-tpl", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTpl && _vm.checkTpl.tplVersion !== 2,
                  expression: "checkTpl && checkTpl.tplVersion !== 2"
                }
              ],
              key: _vm.checkTpl.tplIdSec,
              ref: "web_tpl",
              attrs: { fileTplItem: _vm.checkTpl },
              on: {
                "update:fileTplItem": function($event) {
                  _vm.checkTpl = $event
                },
                "update:file-tpl-item": function($event) {
                  _vm.checkTpl = $event
                },
                varListADD: _vm.varListADD,
                turnFirst: _vm.turnFirst
              }
            })
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-500c2e3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500c2e3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/tplSetting.vue
// module id = GjtM
// module chunks = 2 3 6 8 15